import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';

const AdvanceCollectionOptions = ({
  projectId,
  version,
  collectionId,
  collectionTitle,
  itemData,
  filename,
  deleteAllItems,
  flag,
  isReadOnly,
}) => {
  return (
    <UncontrolledDropdown group className="custom-pad-right-1 pr-2" style={{ zIndex: '1100' }}>
      <DropdownToggle color="theme-warning" title="Advanced Options" className="btn-md" caret>
        <i className="wb webconnect-cogs"></i> Advance
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem>
          <Link
            to={
              isReadOnly
                ? '#'
                : `/collections/${version}/v/${projectId}/import-data/${collectionId}/`
            }
            title={isReadOnly ? 'Read-only mode' : 'Import Data'}
            className="no-hover"
            onClick={(e) => {
              if (isReadOnly) {
                e.preventDefault();
              }
            }}
            style={{
              opacity: isReadOnly ? 0.5 : 1,
              cursor: isReadOnly ? 'not-allowed' : 'pointer',
            }}
          >
            <i className="wb webconnect-upload"></i> Import Data
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link
            to={isReadOnly ? '#' : `/collections/${version}/v/${projectId}/dump/${collectionId}`}
            title={isReadOnly ? 'Read-only mode' : 'Export Data To File'}
            className="no-hover"
            onClick={(e) => {
              if (isReadOnly) {
                e.preventDefault();
              }
            }}
            style={{
              opacity: isReadOnly ? 0.5 : 1,
              cursor: isReadOnly ? 'not-allowed' : 'pointer',
            }}
          >
            <i className="wb webconnect-cloud-arrow-down" />
            &nbsp;Export Data Dump
          </Link>
        </DropdownItem>

        <DropdownItem
          title={
            isReadOnly
              ? 'Read-only mode'
              : collectionTitle
              ? `Delete All Records of ${collectionTitle}`
              : 'Delete Collection Records'
          }
          disabled={isReadOnly || !flag}
          onClick={isReadOnly || !flag ? undefined : deleteAllItems}
          style={{
            cursor: isReadOnly || !flag ? 'not-allowed' : 'pointer',
            opacity: isReadOnly ? 0.5 : 1,
          }}
          className="theme-red"
        >
          <i className="wb webconnect-trash-regular" />
          &nbsp; Delete All Records &nbsp;
          {isReadOnly ? (
            <TooltipInfo
              title="Read-only mode"
              headerText="Permission Disabled!"
              showHeader={true}
              showArrow={true}
            />
          ) : flag ? null : (
            <TooltipInfo
              title={description}
              headerText="Permission Disabled!"
              showHeader={true}
              showArrow={true}
            />
          )}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default AdvanceCollectionOptions;
